export default "__VITE_ASSET__BiQ8JGmW__"